<template>
 <div class=""
 style="margin-top:10%"
 >
 <b-row>
      <b-col cols="7"><h1 class="text-right">UNDER CONSTRUCTION</h1></b-col>
      <b-col><img  class="ml-5" src="/img/gear.jpg" alt="" width="50" height="50">
      </b-col>
      </b-row>
    <b-row>
      <b-col></b-col>
      <b-col>
        <div class="text-center">
          <br><br>
          <img class="mb-4" src="/img/logo-enterprise.png" alt="" width="400" height="80">
          <h1 class="h3 mb-3 font-weight-normal">Sign in</h1>
          <label for="inputEmail" class="sr-only">User</label>
          <input type="email" id="inputEmail" class="form-control" placeholder="User" required autofocus>
          <label for="inputPassword" class="sr-only">Password</label>
          <input type="password" id="inputPassword" class="form-control" placeholder="Password" required>
          <br>
          <button class="btn btn-lg btn-primary " type="submit">Sign in</button>
        </div>
      </b-col>
      <b-col></b-col>
    </b-row>
 </div> 
</template>

<script>
// @ is an alias to /src
import masternav           from '@/components/masternav.vue'
import maincontent         from '@/components/maincontent.vue'
import mainfooter          from '@/components/mainfooter.vue'
import rents               from '@/components/rents.vue'
import footsecondary       from '@/components/footsecondary.vue'
import contactcomp         from '@/components/contactcomp.vue'
import reservestep1and2    from '@/components/reservestep1and2.vue'

export default {
  name: 'Maintenance',
  metaInfo: {
      title: "Enterprise Panama - Mantenimiento | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
  components: {
    masternav,
    mainfooter,
    maincontent,
    rents,
    footsecondary,
    contactcomp,
    reservestep1and2
  }
}
</script>

<style scoped lang="scss">
#app {
  background-color: #c72a2a;
  color: #2c3e50;
}
.under{
  background-color: #15804d;
   /*  height: 59px !important;
    width: 60px;
    margin-top: -12px !important;
    border: none !important;
    border-left: 1px solid #006639 !important;
    color: white;
    outline: none;
    position:absolute;
    right:0px; */
}
.body {
    
    background-color: #c72a2a;
}

</style>


